import { request } from './http';
import type { BillingProfile, BillingProfileDraft, CardholderRegisterResult } from '@/types/billing';
import type { PaginatedResult } from '@/types/api';

export const billingApi = {
  list(query: { page?: number; pageSize?: number; keyword?: string } = {}) {
    return request<PaginatedResult<BillingProfile>>({
      url: '/billing-profiles',
      method: 'GET',
      params: query,
    });
  },
  detail(id: string) {
    return request<BillingProfile>({ url: `/billing-profiles/${id}`, method: 'GET' });
  },
  create(payload: BillingProfileDraft) {
    return request<BillingProfile>({
      url: '/billing-profiles',
      method: 'POST',
      data: payload,
    });
  },
  update(id: string, payload: Partial<BillingProfileDraft>) {
    return request<BillingProfile>({
      url: `/billing-profiles/${id}`,
      method: 'PUT',
      data: payload,
    });
  },
  remove(id: string) {
    return request<void>({ url: `/billing-profiles/${id}`, method: 'DELETE' });
  },
  registerCardholder(id: string) {
    return request<CardholderRegisterResult>({
      url: `/billing-profiles/${id}/register-cardholder`,
      method: 'POST',
    });
  },
};
